import React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';
import { animateScroll as scroll } from 'react-scroll';
import {
  Button,
  BodyText,
  HeadingText,
  Link,
  Modal,
  blue800,
} from '@paypalcorp/pp-react';

import SimpleHeader from './SimpleHeader';
import Paragraph from './Paragraph';
import CobrandedHeader from './cobranded-header';
import DonationModal from './DonationModal';

import styles from './HeroModule.less';

import * as analytics from '../lib/analytics';
import parseAmount from '../lib/parseAmount';

export default class extends React.Component {
  constructor(props) {
    super(props);
    var isMobile = false;
    var isTablet = false;
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
    }

    if (/iPad/i.test(navigator.userAgent)) {
      isTablet = true;
    }

    var desktopView = window.innerWidth > 767 && !isMobile && !isTablet;

    const charity = get(props.campaignInfo, 'charities[0]', {});
    let nonanonymous = true;
    if (get(charity, 'address.country_code') === 'GB') {
      nonanonymous = false;
    }

    const tickerSectionEnabled = get(
      props.campaignInfo,
      'tickerSectionEnabled',
      false
    );

    this.state = {
      HideCenter: false,
      isMobile: false,
      videoPlayStyle: 'videoPlay',
      errorPopup: false,
      desktopView: desktopView,
      clickedIndex: -1,
      inputAmount: '',
      selectedAmount: '',
      nonanonymous,
      showModal: false,
      tickerSectionEnabled,
    };
  }

  handleNonAnonymousCheck = (event) => {
    this.setState(
      Object.assign({}, this.state, {
        nonanonymous: event.target.checked,
      })
    );
  };

  handleScrollButton = (event) => {
    event.preventDefault();
    let campaignInfo = this.props.campaignInfo;
    if (campaignInfo.state === 'ACTIVE') {
      scroll.scrollTo(
        document.getElementById(this.buttonScroll.hash.slice(1)).offsetTop - 50
      );
    }
  };

  resizeScreen = () => {
    if (window.innerWidth <= 767) {
      this.setState({
        desktopView: false,
      });
    } else {
      this.setState({
        desktopView: true,
      });
    }
  };

  componentDidMount() {
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.setState({
        HideCenter: true,
        isMobile: true,
      });
    }

    let campaignInfo = this.props.campaignInfo;

    window.addEventListener('resize', this.resizeScreen);
  }

  handleSuspendedButton = (event) => {
    analytics.trackLink(
      'suspendedbuttonclick',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleClickSubmitEvent = (event) => {
    if (
      this.state.inputAmount === '' &&
      (!this.state.radioBtnClicked || this.state.selectedAmount === '')
    ) {
      event.preventDefault();
      this.invalid();
      this.setState({
        errorPopup: true,
      });
      setTimeout(() => {
        this.setState({
          errorPopup: false,
        });
      }, 2000);
    } else {
      let amount;
      if (this.state.inputAmount !== '') {
        amount = this.state.inputAmount;
      } else {
        amount = this.state.selectedAmount;
      }
      analytics.trackLinkWithData(
        'linkdonatebutton',
        this.props.fptiInfo.pgrp,
        this.props.fptiInfo.page,
        { amt: amount, nonanonymous: this.state.nonanonymous },
        'link'
      );
    }
  };

  handleInputChange = (event) => {
    const value = event.target.value;
    let input = parseAmount(value);
    if (input === undefined) {
      return this.invalid();
    }

    this.setState({
      inputAmount: input,
    });
  };

  handleInputFocus = () => {
    this.setState({
      selectedAmount: '',
      radioBtnClicked: false,
      clickedIndex: -1,
    });
  };

  invalid = () => {
    this.setState({
      isInvalid: true,
    });

    setTimeout(() => {
      this.setState({
        isInvalid: false,
      });
    }, 200);
  };

  onRadioClick = (selectedAmount, index) => {
    this.setState({
      selectedAmount,
      clickedIndex: index,
      radioBtnClicked: true,
      inputAmount: '',
    });
  };

  toggleModal = (value) => this.setState({ showModal: value });

  renderModal = () => {
    return (
      <Modal
        isOpen={this.state.showModal}
        onClose={() => this.toggleModal(false)}
        id={'singleCharityDonationModal'}
      >
        <DonationModal
          i18n={this.props.i18n}
          campaignInfo={this.props.campaignInfo}
          enable={this.props.enable}
          isMobile={this.state.isMobile}
          fptiInfo={this.props.fptiInfo}
          csrf={this.props.csrf}
          charity={this.props.campaignInfo.charities[0]}
          cdnHost={this.props.cdnHost}
        />
      </Modal>
    );
  };

  renderHeader = () => {
    const cobranded = get(
      this.props.campaignInfo.templateData,
      'campaignBranding.campaignBrand',
      ''
    );

    const logo = get(
      this.props.campaignInfo.templateData,
      'lpContents.logoImage'
    );
    if (cobranded.toUpperCase() === 'COBRANDED' && logo) {
      return (
        <CobrandedHeader cobrandedLogo={logo} cdnHost={this.props.cdnHost} />
      );
    } else {
      return (
        <SimpleHeader cdnHost={this.props.cdnHost} domain={this.props.domain} />
      );
    }
  };

  render() {
    let campaignInfo = this.props.campaignInfo;
    let templateData = campaignInfo.templateData;
    let donorsOrAmount = '';
    if (templateData.lpContents.donorsOrAmount === 'donors') {
      donorsOrAmount = campaignInfo.transactionSummary.totalNumberOfTransaction;
    } else {
      // TODO: Revisit value we get from the server
      donorsOrAmount = campaignInfo.transactionSummary.totalAmount;
    }
    var bgImageUrl = templateData.lpContents.bgImage;
    let numCharities = campaignInfo.charities
      ? campaignInfo.charities.length
      : 0;

    let realTime = templateData.lpContents.realTime;

    let heroStyling = classNames('hero', {
      singleCharity: numCharities === 1,
    });

    let tickerStyling = classNames('center', {
      hide:
        (this.state.HideCenter && !this.state.tickerSectionEnabled) ||
        templateData.lpContents.donorsOrAmount === 'none',
    });

    let ButtonScrollStyling = classNames('scrollLink', {
      pointer:
        campaignInfo.state === 'SUSPENDED' || campaignInfo.state === 'INACTIVE',
      desktopDonateView:
        this.state.desktopView &&
        campaignInfo.state !== 'SUSPENDED' &&
        numCharities <= 1,
    });

    let btnPrimaryStyling = classNames('btn btn-primary btn_primary vx_btn', {
      desktopDonateView:
        this.state.desktopView &&
        campaignInfo.state !== 'SUSPENDED' &&
        numCharities <= 1,
    });

    let heroParaStyling = classNames('heroPara', {
      marginHeroPara: templateData.lpContents.donorsOrAmount === 'none',
    });

    let donate = classNames('donate', {
      desktopDonateView:
        this.state.desktopView &&
        campaignInfo.state !== 'SUSPENDED' &&
        numCharities <= 1,
    });

    let IEbrowser =
      navigator.userAgent.indexOf('MSIE') > 0 ||
      navigator.appVersion.indexOf('Trident/') > 0 ||
      navigator.appName === 'Microsoft Internet Explorer';

    const charity = get(campaignInfo, 'charities[0]', {});
    let name;
    if (
      charity.charity_type === 'PPGF_DIRECT' ||
      charity.charity_type === 'DIRECT_MODEL_ENROLLED'
    ) {
      name = this.props.i18n('label.donation-description', {
        charity: charity.name,
      });
    } else {
      name = this.props.i18n('label.ppgf-donation-description', {
        charity: charity.name,
      });
    }

    const tickerBox = (
      <div className={tickerStyling}>
        {/* {realTime === 'yes' && <TickerBox id={campaignInfo.id} donorOrAmount={templateData.lpContents.donorsOrAmount} txnSummary={campaignInfo.transaction_summary} pollInterval={1000}/>} */}
        {realTime === 'no' && (
          <>
            <HeadingText id='transaction-summary' as='p' size='hero'>
              {donorsOrAmount}
            </HeadingText>
          </>
        )}
        <BodyText
          as='p'
          className={this.state.tickerSectionEnabled ? styles.tickerText : ''}
        >
          {templateData.lpContents.donorsOrAmountText}
        </BodyText>
      </div>
    );

    return (
      <>
        <div
          className={heroStyling}
          style={{
            background: 'url(' + bgImageUrl + ') no-repeat top',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundColor: blue800,
          }}
        >
          {this.renderHeader()}
          <div className='hero_parent'>
            <div className='hero_content'>
              <div className='intro'>
                {(campaignInfo.state === 'ACTIVE' ||
                  campaignInfo.state === 'PREVIEW') && (
                  <HeadingText as='p' size='hero' className='campaign_header'>
                    {campaignInfo.campaignTitle}
                  </HeadingText>
                )}
                {(campaignInfo.state === 'SUSPENDED' ||
                  campaignInfo.state === 'INACTIVE') && (
                  <HeadingText as='p' size='hero' className='campaign_header'>
                    {this.props.i18n('label.campaign-suspended-header')}
                  </HeadingText>
                )}
                {!this.state.tickerSectionEnabled && tickerBox}
                {(campaignInfo.state === 'ACTIVE' ||
                  campaignInfo.state === 'PREVIEW') &&
                  campaignInfo.campaignDesc && (
                    <Paragraph
                      className={heroParaStyling}
                      content={campaignInfo.campaignDesc}
                    />
                  )}
                {(campaignInfo.state === 'SUSPENDED' ||
                  campaignInfo.state === 'INACTIVE') && (
                  <Paragraph
                    className={heroParaStyling}
                    content={this.props.i18n('title.campaign-expired')}
                  />
                )}
                <div className={donate} style={{ textAlign: 'center' }}>
                  {numCharities === 1 &&
                    (campaignInfo.state === 'ACTIVE' ||
                      campaignInfo.state === 'PREVIEW') && (
                      <div>
                        <Button
                          type='submit'
                          data-ppvx_modal-id='singleCharityDonationModal'
                          disabled={campaignInfo.state === 'PREVIEW'}
                          className={styles.donateButton}
                          onClick={() => this.toggleModal(true)}
                        >
                          {templateData.lpContents.donateButtonText}
                        </Button>
                        {this.renderModal()}
                      </div>
                    )}
                  {(campaignInfo.state === 'SUSPENDED' ||
                    campaignInfo.state === 'INACTIVE') && (
                    <Link
                      ref={(element) => (this.buttonScroll = element)}
                      onClick={this.handleSuspendedButton}
                      target='_blank'
                      href={
                        templateData.lpContents.campaignExpiryRedirectionLink
                          ? templateData.lpContents
                              .campaignExpiryRedirectionLink
                          : '/fundraiser/hub'
                      }
                    >
                      <Button type='button'>
                        {this.props.i18n('label.donate-button-expired')}
                      </Button>
                    </Link>
                  )}
                  {templateData.lpContents.impactStmntNeeded === 'yes' && (
                    <p className='impactStmt'>
                      {templateData.lpContents.impactStmntText}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.tickerSectionEnabled && (
          <div className={'module1 ' + styles.tickerBox}>{tickerBox}</div>
        )}
      </>
    );
  }
}
